module.exports = __webpack_public_path__ + "img/chevron-left.18632d57.svg";